function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  y: 14,
  width: 30,
  height: 1,
  fill: "#d02f44"
}), /*#__PURE__*/React.createElement("rect", {
  y: 12,
  width: 30,
  height: 1,
  fill: "#d02f44"
}), /*#__PURE__*/React.createElement("rect", {
  y: 10,
  width: 30,
  height: 1,
  fill: "#d02f44"
}), /*#__PURE__*/React.createElement("rect", {
  y: 8,
  width: 30,
  height: 1,
  fill: "#d02f44"
}), /*#__PURE__*/React.createElement("rect", {
  y: 6,
  width: 30,
  height: 1,
  fill: "#d02f44"
}), /*#__PURE__*/React.createElement("rect", {
  y: 4,
  width: 30,
  height: 1,
  fill: "#d02f44"
}), /*#__PURE__*/React.createElement("rect", {
  y: 2,
  width: 30,
  height: 1,
  fill: "#d02f44"
}), /*#__PURE__*/React.createElement("rect", {
  width: 30,
  height: 1,
  fill: "#d02f44"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  width: 11,
  height: 7,
  fill: "#46467f"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
  cx: 8.36,
  cy: 5,
  rx: 0.52,
  ry: 0.52,
  fill: "#eee"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 6.26,
  cy: 5,
  rx: 0.52,
  ry: 0.52,
  fill: "#eee"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 4.17,
  cy: 5,
  rx: 0.52,
  ry: 0.52,
  fill: "#eee"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 2.07,
  cy: 5,
  rx: 0.52,
  ry: 0.52,
  fill: "#eee"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 3.12,
  cy: 4.09,
  rx: 0.52,
  ry: 0.52,
  fill: "#eee"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 5.21,
  cy: 4.09,
  rx: 0.52,
  ry: 0.52,
  fill: "#eee"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 7.31,
  cy: 4.09,
  rx: 0.52,
  ry: 0.52,
  fill: "#eee"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 8.36,
  cy: 3.18,
  rx: 0.52,
  ry: 0.52,
  fill: "#eee"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 6.26,
  cy: 3.18,
  rx: 0.52,
  ry: 0.52,
  fill: "#eee"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 4.17,
  cy: 3.18,
  rx: 0.52,
  ry: 0.52,
  fill: "#eee"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 2.07,
  cy: 3.18,
  rx: 0.52,
  ry: 0.52,
  fill: "#eee"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 3.12,
  cy: 2.27,
  rx: 0.52,
  ry: 0.52,
  fill: "#eee"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 5.21,
  cy: 2.27,
  rx: 0.52,
  ry: 0.52,
  fill: "#eee"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 7.31,
  cy: 2.27,
  rx: 0.52,
  ry: 0.52,
  fill: "#eee"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 2.07,
  cy: 1.36,
  rx: 0.52,
  ry: 0.52,
  fill: "#eee"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 4.17,
  cy: 1.36,
  rx: 0.52,
  ry: 0.52,
  fill: "#eee"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 6.26,
  cy: 1.36,
  rx: 0.52,
  ry: 0.52,
  fill: "#eee"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 8.36,
  cy: 1.36,
  rx: 0.52,
  ry: 0.52,
  fill: "#eee"
})));

var SvgUsFlag = function SvgUsFlag(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 15,
    viewBox: "0 0 30 15",
    style: {
      backgroundColor: "white"
    },
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUsFlag, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/us-flag.0a3ff0ea.svg";
export { ForwardRef as ReactComponent };